import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import { CtaButton } from "../Button/CtaButton";
import { StarRatingValue } from "../StarRatingValue";
import { ListCheckmark } from "../ListCheckmark";
import { scrollToComponent } from "../../utils/helpers";
import { useSectionsData } from "../../utils/useSectionsData";
import { getBrandName } from "../../utils/helpers.ts";
import { Product } from "../../types/products";
import glideImage from "../../utils/useGlideImage.ts";

export const Hero = () => {
  const sections = useSectionsData();
  const brandName = getBrandName();
  const staticContent = sections.pp_v7_static_content;
  const reviewCount = staticContent?.global_review_count;
  const starRating = staticContent?.global_star_rating;
  const hero = sections.pp_v7_hero;
  const productImage =
    hero.product_image || `${window.template_root}/v1/bottlesOffer.png`;
  const benefits = hero.benefits;
  const formattedString = window.formattedString;
  const productsData = window.productData;
  const products: Product[] = productsData?.products || [];

  const getLowestAmountProduct = (products: Product[]): Product | undefined => {
    if (products.length === 0) return undefined;

    return products.reduce((prev, curr) => {
      const prevAmount = parseInt(String(prev.amount), 10);
      const currAmount = parseInt(String(curr.amount), 10);

      if (isNaN(prevAmount)) return curr;
      if (isNaN(currAmount)) return prev;

      return currAmount < prevAmount ? curr : prev;
    }, products[0]);
  };

  const lowestProduct = getLowestAmountProduct(products);
  const oldPrice =
    lowestProduct &&
    formattedString.replace(/(0\.00|0,00|0)/, lowestProduct.old_price);
  const price =
    lowestProduct &&
    formattedString.replace(/(0\.00|0,00|0)/, lowestProduct.price);

  return (
    <PageWrapper backgroundColor="section_light">
      <div className={s.header}>
        <div className={s.header__left}>
          <h1 dangerouslySetInnerHTML={{ __html: hero.tr_main_heading }}></h1>
          <ul>
            {benefits.map((item: { tr_text: string }, index: number) => (
              <ListCheckmark dangerousHTML={item.tr_text} key={index} />
            ))}
          </ul>
          <div className={s.header__leftBottom}>
            <div className={s.header__rating}>
              <StarRatingValue rating={starRating} />
              <div>{starRating}</div>
              <div
                className={s.header__reviewsNumber}
              >{`${reviewCount} ${staticContent.tr_reviews_label}`}</div>
            </div>
            <CtaButton
              text={hero.tr_cta_label}
              onClick={() => scrollToComponent("products")}
            />
          </div>
        </div>
        <div className={s.header__right}>
          <img
            src={glideImage(productImage, { w: 304, h: 270 })}
            height={270}
            width={304}
            alt={brandName}
          />
          <div className={s.header__rightBottom}>
            <span
              className={s.header__limitedTimeText}
              dangerouslySetInnerHTML={{ __html: hero.tr_banner_label_top }}
            ></span>
            <div className={s.header__pricesText}>
              <div>{oldPrice}</div>
              <div>{price}</div>
              {`/${staticContent.tr_each_label}`}
            </div>
            <div className={s.header__limitedSaleText}>
              <span
                dangerouslySetInnerHTML={{
                  __html: hero.tr_banner_label_bottom_left,
                }}
              ></span>
              <span
                dangerouslySetInnerHTML={{
                  __html: hero.tr_banner_label_bottom_right,
                }}
              ></span>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};
